"use client";

import { Link, useLocation } from "react-router-dom";
import { useUserStore } from "../../store/user-store";

const NavList = () => {
  const location = useLocation(); // Use `useLocation` to get the current path
  const pathname = location.pathname; // Extract `pathname` from location
  // Cuenta de Google sin contraseña: la pestaña sirve para definirla.
  const hasPassword = (useUserStore((s) => s.user) as any)?.has_password;

  return (
    <>
      <ul className="ps-0 mb-4 list-unstyled d-flex flex-wrap gap-2 gap-lg-3">
        <li>
          <Link
            to="/my-profile"
            className={`btn border border-primary text-primary py-2 px-3 fw-semibold ${pathname === "/my-profile"
                ? "btn-primary text-white"
                : "bg-transparent"
              }`}
          >
            Perfil
          </Link>
        </li>
        <li>
          <Link
            to="/settings/account-bank"
            className={`btn border border-primary text-primary py-2 px-3 fw-semibold ${pathname === "/settings/account-bank"
                ? "btn-primary text-white"
                : "bg-transparent"
              }`}
          >
            Información bancaria
          </Link>
        </li>

        <li>
          <Link
            to="/settings/change-password"
            className={`btn border border-primary text-primary py-2 px-3 fw-semibold ${pathname === "/settings/change-password"
                ? "btn-primary text-white"
                : "bg-transparent"
              }`}
          >
            {hasPassword === false ? "Establecer contraseña" : "Cambiar contraseña"}
          </Link>
        </li>

        <li>
          <Link
            to="/settings/security"
            className={`btn border border-primary text-primary py-2 px-3 fw-semibold ${pathname === "/settings/security"
                ? "btn-primary text-white"
                : "bg-transparent"
              }`}
          >
            Seguridad
          </Link>
        </li>

        <li>
          <Link
            to="/settings/address"
            className={`btn border border-primary text-primary py-2 px-3 fw-semibold ${pathname === "/settings/address"
                ? "btn-primary text-white"
                : "bg-transparent"
              }`}
          >
            Direcciones
          </Link>
        </li>

        <li>
          <Link
            to="/settings/documents"
            className={`btn border border-primary text-primary py-2 px-3 fw-semibold ${pathname === "/settings/documents"
                ? "btn-primary text-white"
                : "bg-transparent"
              }`}
          >
            Documentos
          </Link>
        </li>
       {/*  <li>
          <Link
            to="/settings/privacy-policy"
            className={`btn border border-primary text-primary py-2 px-3 fw-semibold ${pathname === "/settings/privacy-policy"
                ? "btn-primary text-white"
                : "bg-transparent"
              }`}
          >
            Privacy Policy
          </Link>
        </li> */}
        <li>
          <Link
            to="/settings/terms-conditions"
            className={`btn border border-primary text-primary py-2 px-3 fw-semibold ${pathname === "/settings/terms-conditions"
                ? "btn-primary text-white"
                : "bg-transparent"
              }`}
          >
            Terminos y condiciones
          </Link>
        </li>

      </ul>
        
    </>
  );
};

export default NavList;
